


































































































































































































































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import sha1 from 'sha1'
import { WECHAT_APPID, WECAHT_NAME, IMG_URL } from '@/utils/constants'
import { wxShare } from '@/utils/wxApi'

import polygonDataJson from '@/service/610523.json'
import cityPolygonDataJson from '@/service/610523_city.json'
import preColors from './json/pre_colors.json'
import temColors from './json/tem_colors.json'

import buttonGroup from './button_group.vue'
import filterCondition from './filter_sub_button.vue'
import colorGroup from './color_group.vue'
import colorGroupAll from './color_group_all.vue'
import tableView from './table_view.vue'

import MapService from '@/service/MapService'
import RadarService from '@/service/RadarService'
import SatelliteService from '@/service/SatelliteService'
import RSController from './RSController.vue'
import warningImg from '@/utils/warningImg'
import radarSelector from './radar_selector.vue'
import statistics from './statistics.vue'
import barButtonGroup from './bar_button_group.vue'

import * as L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { LMap, LFeatureGroup, LTileLayer, LPolygon, LImageOverlay, LMarker, LIcon, LGeoJson, LPopup } from 'vue2-leaflet'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import CimissDataService from '@/service/CimissDataService'
import { number } from 'echarts'
import statisticsList from "@/assets/json/statisticsList.json";
import ColorGroupBoxCrosswise from './color_group_box_crosswise.vue'
import townList from "@/assets/json/townList.json";
L.Icon.Default.imagePath = 'leaflet/dist/images/'
const options = {
  subdomains: [0, 1, 2, 3, 4, 5, 6, 7],
  key: '968095801756581d1f1265e80313909e',
}


export default Vue.extend({


  components: {
    LMap,
    LFeatureGroup,
    LTileLayer,
    LPolygon,
    LImageOverlay,
    LMarker,
    LIcon,
    LGeoJson,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
    LPopup,
    buttonGroup,
    barButtonGroup,
    filterCondition,
    colorGroup,
    tableView,
    RSController,
    colorGroupAll,
    radarSelector,
    statistics,
    ColorGroupBoxCrosswise
    // tileLayerChange,
  },
  // const EPSG3395: CRS;
  //   const EPSG3857: CRS;
  //   const EPSG4326: CRS;
  //   const Earth: CRS;
  //   const Simple: CRS;
  data() {
    return {
      zoom: 9.8,
      crs: L.CRS.EPSG3857,
      center: [config.defaultStationObj.lat, config.defaultStationObj.lon],
      cityPostion: [config.defaultStationObj.lat, config.defaultStationObj.lon],
      option: {
        zoomSnap: 0.2, attributionControl: false, zoomControl: false,
        dragging: true, scrollWheelZoom: true,
      },
      flag: 0,
      options,
      // url1: 'http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetGray/MapServer/tile/{z}/{y}/{x}',
      url1: 'http://thematic.geoq.cn/arcgis/rest/services/ThematicMaps/administrative_division_boundaryandlabel/MapServer/tile/{z}/{y}/{x}',
      // url1: 'http://t{s}.tianditu.com/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk={key}',
      // url1: 'http://map.geoq.cn/arcgis/rest/services/SimpleFeature/ChinaBoundaryLine/MapServer/tile/{z}/{y}/{x}',

      // url1:'',
      url2: 'http://t{s}.tianditu.com/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk={key}',
      url3: 'http://t{s}.tianditu.com/DataServer?T=img_w&X={x}&Y={y}&L={z}&tk={key}',
      url4: 'http://t{s}.tianditu.com/DataServer?T=cia_w&X={x}&Y={y}&L={z}&tk={key}',
      polygon: [] as any,
      polygonData: polygonDataJson,
      cityPolygonData: cityPolygonDataJson,
      geoStyle: {
        color: '#1186F2',
        fillColor: '#FFFFFF',
        weight: 1,
        opacity: 0.3,
        fillOpacity: 0,
        // dashArray: [5, 5],
        fill: false,
      },
      cityGeoStyle: {
        color: '#0072f1',
        fillColor: '#5FB2FF',
        weight: 1.5,
        opacity: 1,
        fillOpacity: 0.2,
        // dashArray: [5, 5],
        // fill: false
      },
      popupOption: {
        className: 'popup'
      },
      warnPopupOption: {
        className: 'warn-popup'
      },
      barId: '',
      subId: '',
      mapTitle: '' as any,
      mapUnit: '' as any,
      popupLabel: '' as any,
      timeStr: '',
      initData: [],
      checkConditionObj: {
        check: false,
        data: {} as any,
      },
      beforeMapData: [],
      townInfoData: [] as any,
      mapData: [],
      mapStationData: [],
      showSpin: true,
      colors: [] as any,
      geojson: {} as any,
      isColor: false,
      fillColorShow: true,
      isTableShow: false,
      imageGroup: [],
      overlayUrl: '',
      overlayBounds: [],
      warnInfos: [] as any,
      bounds: [],
      alarm: {},
      modalShow: false,
      radarProductShow: false,
      disasterWarnings: [],
    }
  },

  async created() {
    this.barId = this.$route.params.id
    this.subId = this.barId
    document.title = this.getWindowTitle(this.barId) as any
    // polygon.map((e: any) => {
    //   this.polygon.push([e[1], e[0]])
    // })
    if (this.barId === 'pre' || this.barId === 'tem') {
      this.fillColorShow = true
    } else {
      this.fillColorShow = false
    }


    // fetch("../static/json/610523.json")
    //   .then(res => res.json())
    //   .then(res => {
    //     this.polygonData = res
    //     console.log(this.polygonData)
    //   })
    //   .catch(err => {
    //     //解析错误或者获取数据失败
    //   })


    // fetch("../static/json/610523_city.json")
    //   .then(res => res.json())
    //   .then(res => {
    //     this.cityPolygonData = res
    //   })


    this.mapTitle = this.getMapTitle(this.barId)
    this.mapUnit = this.getMapUnit(this.barId)
    this.popupLabel = this.getPopupLabel(this.barId)
    // await RadarService.listImgBounds('z9290').then((res: any) => this.bounds = res)
    this.changeBar(this.barId)
    this.getWarnInfo()
    this.initWeixin()
  },

  methods: {

    async changeBar(value: any) {
      this.showSpin = true
      this.colors = []
      this.geojson = {}
      this.initData = []
      this.barId = value
      let data = [] as any
      if (this.barId === 'radar') {
        // await RadarService.listStationImgJson('z9734').then((res: any) => data = res)
        await RadarService.list().then((res: any) => data = res)
      } else if (this.barId === 'satellite') {
        await SatelliteService.list().then((res: any) => data = res)
        this.imageGroup = data
      } else if (this.barId === 'pre' || this.barId === 'tem') {
        this.fillColorShow = true
      } else {
        this.fillColorShow = false
        this.isColor = false
      }
      this.mapTitle = this.getMapTitle(this.barId)
      this.mapUnit = this.getMapUnit(this.barId)
      this.popupLabel = this.getPopupLabel(this.barId)

      this.flag = 0
      if (this.barId === 'radar') {
        this.imageGroup = data
        console.log(this.imageGroup)
        this.zoom = 7.6
        this.$set(this.option, 'dragging', true)
        this.$set(this.option, 'scrollWheelZoom', true)
        this.flag = 1
      } else if (this.barId === 'radar_mosaic') {
        this.zoom = 7.6
        this.flag = 2

      } else if (this.barId === 'satellite') {
        this.zoom = 7.6
        this.center = this.cityPostion
        this.$set(this.option, 'dragging', false)
        this.$set(this.option, 'scrollWheelZoom', false)
      } else {
        this.flag=0
        this.imageGroup = []
        this.zoom = 9.8
        this.$set(this.option, 'dragging', true)
        this.$set(this.option, 'scrollWheelZoom', true)
        this.overlayUrl = ''
        this.overlayBounds = []
      }
    },
    changeSub(value: any) {
      this.subId = value
      this.flag = 0
    },
    // getImageGroupChange(value: any) {
    //   const item: any = value.item
    //   const imageBounds: any = [[this.bounds[1][1], this.bounds[0][0]], [this.bounds[0][1], this.bounds[1][0]]]
    //   this.overlayUrl = item.FILEPATH

    //   if (this.barId === 'radar') {
    //     this.overlayBounds = imageBounds
    //   } else {
    //     this.overlayBounds = value.imageBounds
    //   }
    // },
    getImageGroupChange(value: any) {
            console.log(value)
            const item: any = value.item
            const imageBounds: any = [[item.MINLAT, item.MINLON], [item.MAXLAT, item.MAXLON]]
            this.overlayUrl = 'http://wenerproduct.sxktqx.com/'+item.filepath
            this.overlayBounds = value.imageBounds
        },
    getData(value: any) {
      if (this.barId === 'radar' || this.barId === 'satellite') {
        return
      }
      console.log(value)
      this.colors = []
      this.geojson = {}
      this.timeStr = value.timeStr
      this.initData = JSON.parse(JSON.stringify(value.data))
      this.checkCondition(this.checkConditionObj)
    },
    async checkCondition(value: any) {
      this.checkConditionObj = value
      const arr = JSON.parse(JSON.stringify(this.initData))
      let newData = []
      const { check, data } = this.checkConditionObj
      if (check) {
        if (data.value.length === 2) {
          newData = arr.filter((i: any) => {
            return i.level === data.value[0] || i.level === data.value[1]
          })
        } else if (data.tag === '>=') {
          if (this.barId === 'wind') {
            newData = arr.filter((i: any) => {
              return i.level >= data.value
            })
          } else {
            newData = arr.filter((i: any) => {
              return i.value >= data.value
            })
          }
        } else if (data.tag === '<=') {
          if (this.barId === 'wind') {
            newData = arr.filter((i: any) => {
              return i.level <= data.value
            })
          } else {
            newData = arr.filter((i: any) => {
              return i.value <= data.value
            })
          }
        }
      } else {
        newData = arr
      }
      // 过滤为空的数据
      newData = newData.filter((e: any) => {
        return e.value != null
      })
      this.beforeMapData = newData
      this.mapData = JSON.parse(JSON.stringify(newData))
      this.mapData.map((e: any) => {
        if (e.station_name.length > 2) {
          e.station_name = e.station_name.replaceAll('大荔', '')
        }
        if (e.station_name === '渭南沙苑') {
          e.station_name = '沙苑'
        }
        if (e.station_name === '产业园气象观测站') {
          e.station_name = '黄河围堤'
        }
      })
      this.mapStationData = this.mapData
      this.getMapColor()
    },
    async checkRadar(value: any) {
      this.zoom = 8
      this.$set(this.option, 'dragging', true)
      this.$set(this.option, 'scrollWheelZoom', true)
      this.imageGroup = []

      //单站雷达
      if (value.startsWith('z')) {
        this.center = this.cityPostion
        let bounds = [] as any
        await RadarService.listImgBounds(value).then((res: any) => bounds = res)
        this.bounds = bounds
        let data = [] as any
        await RadarService.listStationImgJson(value).then((res: any) => data = res)
        this.imageGroup = data
      }
      //雷达拼图 
      else {
        this.zoom = 3.5
        this.flag = 2
        let area = "CHN"
        if (value === 'centralchina') {
          area = "HZ"
        }
        else if (value === 'northchina') {
          area = "HB"
        } else {
          area = "CHN"
        }

        let data = [] as any
        await RadarService.listRadarProductList(area).then((res: any) => data = res)
        this.imageGroup = data
        let bounds = [[]] as any
        if (data && data.length > 0) {
          const imgData = data[0]
          bounds[0] = []
          bounds[0][0] = imgData.MINLON
          bounds[0][1] = imgData.MINLAT
          bounds[1] = []
          bounds[1][0] = imgData.MAXLON
          bounds[1][1] = imgData.MAXLAT
          this.bounds = bounds
        }

      }
    },
    getColors() {
      let key = ""
      if (this.subId === "pre") {
        key = "pre_1h"
      } else if (this.subId === 'pre_0808' || this.subId === 'pre_2020') {
        key = 'pre_any'
      } else if (this.subId.startsWith("tem")) {
        key = 'tem'
      } else {
        key = this.subId;
      }
      // @ts-ignore
      const detailStatJson = statisticsList[key].data;
      const colorSettings = [];
      for (const item of detailStatJson) {
        const value = item.value;
        const rgbcolor = item.rgbcolor;
        colorSettings.push([
          value[0], value[1], rgbcolor[0], rgbcolor[1], rgbcolor[2]
        ]);
        colorSettings.push(rgbcolor[0]);
      }
      return colorSettings
    },
    fillColor() {
      this.showSpin = true
      this.colors = []
      this.geojson = {}
      // this.$nextTick()
      this.isColor = !this.isColor
      this.getMapColor()
    },

    async getMapColor() {

      const data = JSON.parse(JSON.stringify(this.beforeMapData))
      if (this.isColor === true) {
        this.colors = this.getColors()
        this.geojson = await MapService.getGeoJson(this.mapData, this.barId, this.subId)
        this.mapData.map((e: any) => {
          if (e.bgColor) {
            e.bgColor = '#00BFFF'
          }
        })
      } else {
        this.colors = []
        this.geojson = {}
        this.mapData = data
      }
      this.showSpin = false
    },
    styleFunction() {
      return (feature: any) => {
        const colorJson: any[] = this.colors
        const lvalue = feature.properties.lvalue
        let color = '0,0,0,0'
        for (const item of colorJson) {
          if (item.length < 5) {
            continue
          }
          if (lvalue < item[1]) {
            color = item[2] + ',' + item[3] + ',' + item[4]
            break
          }
        }
        if (color === '0,0,0') {
          // color = '154, 154, 154'
          color = '0,0,0,0'
        }
        // if (color === '255,255,255') {
        //     color = '0, 0, 0, 0.1'
        // }
        return {
          radius: 100,
          fillColor: 'rgb(' + color + ')',
          color: 'rgb(' + color + ')',
          weight: 1,
          fillOpacity: 0.7,
        }
      };
    },

    showTable(value: any) {
      this.isTableShow = value
    },
    markerChange(mapObj: any) {
      // console.log(mapObj.latlng.lat)
      // console.log(mapObj.latlng.lng)
    },
    getMapTitle(value: any) {
      if (value === 'tem') {
        return '气温图'
      } else if (value === 'pre') {
        return '降水图'
      } else if (value === 'wind') {
        return '风速风向图'
      } else if (value === 'rhu') {
        return '湿度图'
      } else if (value === 'radar') {
        return '雷达图'
      } else if (value === 'satellite') {
        return '卫星图'
      } else if (value === 'prs') {
        return '气压图'
      }
    },
    getMapUnit(value: any) {
      if (value === 'tem') {
        return '℃'
      } else if (value === 'pre') {
        return 'mm'
      } else if (value === 'wind') {
        return 'm/s'
      } else if (value === 'rhu') {
        return '%'
      } else if (value === 'prs') {
        return 'Hpa'
      }
    },
    getPopupLabel(value: any) {
      if (value === 'tem') {
        return '温度'
      } else if (value === 'pre') {
        return '降水'
      } else if (value === 'wind') {
        return '风速'
      } else if (value === 'rhu') {
        return '湿度'
      } else if (value === 'prs') {
        return '气压'
      }
    },
    getWindowTitle(value: any) {
      if (value === 'radar' || value === 'radar_mosaic' || value === 'satellite') {
        return '雷达卫星'
      }
      return '实况监测'
      // if (value === 'tem') {
      //   return '实况监测'
      // } else if (value === 'pre') {
      //   return '降水监测'
      // } else if (value === 'wind') {
      //   return '风速风向'
      // } else if (value === 'rhu') {
      //   return '相对湿度'
      // } else if (value === 'radar') {
      //   return '雷达图、卫星云图'
      // }
    },


    getWarnInfo() {
      this.warnInfos = []
      this.getWarnSingle()


    },
    async initWeixin() {
      const url = window.location.href
      const timestamp = moment().valueOf()
      const nonceStr = 'tongzhouwechat'
      const jsapiTicket = await request.get('/api/account/office_account/jsapi_ticket')
      console.log('jsapiTicket', jsapiTicket)
      const params = `jsapi_ticket=${jsapiTicket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`
      console.log('params', params)
      const signature = sha1(params)
      const obj = {
        appId: WECHAT_APPID,
        nonceStr: nonceStr,
        signature: signature,
        timestamp: timestamp,
      }

      const shareData = {
        title: WECAHT_NAME,
        desc: document.title,
        imgUrl: IMG_URL,
        link: url,
      };
      wxShare(obj, shareData);
    },

    getWarnSingle() {
      const adminCode = config.defaultStationObj.adminCode
      let warnList: any[] = []
      const that = this
      CimissDataService.warningSignalList(adminCode).then((res: any) => {
       
        if (res && res.length > 0) {
          const alarms = res
          warnList = alarms.filter((e: any) => {
            e.type = '预警信号'
            e.imgUrl = warningImg.getImgSrc(`${e.signaltype}${e.signallevel}`)
            e.fyzn = warningImg.getFyzn(`${e.signaltype}${e.signallevel}`)
            e.background = warningImg.getWarnImgAndColor(`${e.signaltype}${e.signallevel}`).background;
            e.color = warningImg.getWarnImgAndColor(`${e.signaltype}${e.signallevel}`).color;
            const early_content = e.issuecontent
            const contentStr = early_content.split('：')
            if (contentStr.length > 1) {
              e.early_content = contentStr[1]
            }
            return e
          })
          this.warnInfos = this.warnInfos.concat(warnList)
          console.log(this.warnInfos)
        }
      });
    },



    dateStr(dateStr: string, formater: string) {
      if (formater === '') {
        formater = '$1-$2-$3 $4:$5:$6'
      }
      const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
      // 将时间格式化成 yyyy-MM-dd HH:mm:ss
      const formatDateStr = dateStr.toString().replace(pattern, formater);
      return formatDateStr;
    },
    getwarnImgAndColor(level: string) {

      let background = '';
      let imgUrl = '';
      let color = '';
      if (level.indexOf('红色')) {
        color = '#fff';
        background = '#FF2626';
        imgUrl = '/static/image/mapbtn_gis/map_warn_red.png';
      } else if (level.indexOf('橙色')) {
        color = '#333';
        background = '#F78C21';
        imgUrl = '/static/image/mapbtn_gis/map_warn_orange.png';
      } else if (level.indexOf('黄色')) {
        color = '#333';
        background = '#FAED26';
        imgUrl = '/static/image/mapbtn_gis/map_warn_yellow.png';
      } else if (level.indexOf('蓝色')) {
        color = '#fff';
        background = '#0048FF';
        imgUrl = '/static/image/mapbtn_gis/map_warn_blue.png';
      }
      return { background, imgUrl, color };
    },
    showModal(item: any) {
      this.alarm = item
      this.modalShow = true
    },
    fixedNum(val: string) {
      return Number(val).toFixed(1)
    },
  },
  filters: {
    dtFormat(timestamp: number) {
      const time = moment(timestamp, 'YYYYMMDDHHmmss').add(8, 'hour')
      return time.format('YYYY-MM-DD HH:mm:ss')
    },
    otimeFormat(time: string) {
      const padTime = String(time).padStart(4, '0')
      const momentTime = moment(padTime, 'HHmm').add(8, 'hour')
      return momentTime.format('HH:mm')
    },
  },
})
